<mat-toolbar class="menu-topbar" color="primary">
  <button mat-icon-button (click)="nav.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
</mat-toolbar>
<glxy-nav #nav [fixedTopGap]="40" appName="wsp-admin-center" [navAutoSize]="true" class="glxy-nav--light-theme">
  <glxy-nav-panel>
    <glxy-nav-header>
      <div class="glxy-product-nav-header">
        <img src="{{ logoUrl }}" alt="logo" class="app-logo" />
        <span class="app-name"> WordPress Hosting Admin </span>
      </div>
    </glxy-nav-header>

    <div class="glxy-nav-items">
      @if (navItems$ | async; as navItems) {
        @for (navItem of navItems; track navItem) {
          @if (navItem.children === null) {
            <glxy-nav-item
              [route]="navItem.url"
              [icon]="navItem.icon"
              >
              <div class="glxy-nav-items__label">
                {{ navItem.label | translate }}
                @if (navItem.showUpgradeChip) {
                  <span class="tab-upgrade-chip">Pro</span>
                }
              </div>
            </glxy-nav-item>
          }
          @if (navItem.children !== null) {
            <glxy-nav-item-list [icon]="navItem.icon">
              <div class="glxy-nav-items__label">
                {{ navItem.label | translate }}
                @if (navItem.showUpgradeChip) {
                  <span class="tab-upgrade-chip">Pro</span>
                }
              </div>
              <glxy-nav-item-list-items>
                @for (childNavItem of navItem.children; track childNavItem) {
                  <glxy-nav-item [route]="childNavItem.url">
                    <div class="glxy-nav-items__label">
                      {{ childNavItem.label | translate }}
                    </div>
                  </glxy-nav-item>
                }
              </glxy-nav-item-list-items>
            </glxy-nav-item-list>
          }
        }
      }
    </div>
  </glxy-nav-panel>

  <!-- Page Content -->
  <router-outlet></router-outlet>
</glxy-nav>
